module.exports = __webpack_public_path__ + "img/alumnos.0c9b20d9.png";